<template>
  <div class="outBox">
    <!--    <div @click="go">-->
    <!--      开始录屏-->
    <!--    </div>-->
    <!--    <div @click="back">开始回放</div>-->
    <!--    <div id="replayer-container" style="width: 300px;height: 200px"></div>-->
    <div class="topBox">
      <div class="headerBox">
        <div class="left-box">
          <div class="backGround" v-if="liveState===0">
            <div>
              直播倒计时
            </div>
            <!--            <no-ssr>-->
            <flip-countdown class="inline-countdown" v-if="liveTime" :deadline="liveTime"
                            :labels="{ days: '天', hours: '小时', minutes: '分钟', seconds: '秒' }"></flip-countdown>
            <!--            </no-ssr>-->
          </div>

          <img
              :src="liveData.roomShowUrl"
              alt="">

        </div>
        <div class="right-box">
          <div class="right-box-title">{{ liveData.roomName }}</div>
          <div class="right-box-time" style="display: flex;justify-content: space-between">
            <div>
              <!--                          浏览量：82-->
              直播时间：
              {{ formattedLiveTime }}
            </div>
            <div>
              <el-rate v-model="star" disabled></el-rate>
            </div>
          </div>
          <div class="right-box-time">
          </div>
          <div class="right-box-time">
            <div class="right-box-free">
              免费
            </div>
          </div>
          <div v-if="liveState===0" class="right-box-look noOk" @click="joinLive">即将开始
          </div>
          <div v-if="liveState===1" class="right-box-look" @click="joinLive">
            <div class="live-bars">
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
            </div>
            <div> 加入直播</div>
          </div>
          <div v-if="liveState ===2" class="right-box-look outOk" @click="joinLive">
            回放生成中
          </div>
          <div class="tip" v-if="liveState !==2">
            <i class="el-icon-info">讲师可提前20分钟进入，学员可提前10分钟进入</i>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomBox">
      <div class="bottomBox-flex">
        <div class="left-box">
          <div>
            课程概述
          </div>
          <div>
            <!--            <div>课程简介</div>-->
            <div v-html="liveData.description">
            </div>
          </div>
        </div>
        <div class="right-box">
          <div class="right-box-teacher">
            <div><img :src="teacherData.picture" alt=""></div>
            <div>
              <div>{{ teacherData.name }}</div>
              <div>{{ teacherData.introduce }}</div>
            </div>
          </div>
          <div class="right-box-recomme">
            <div>
              <div>推荐课程</div>
              <div class="right-box-recomme-list">
                <div v-for="item in recommendList" :key="item.id" @click="goCourseDetails(item.id)">
                  <div>
                    <img :src="item.roomShowUrl" alt="">
                  </div>
                  <div>
                    <div>{{ item.roomName }}</div>
                    <div>{{ item.userName }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
* {
  padding: 0;
  margin: 0;
}

.backGround {
  position: absolute;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 514px;
  height: 265px;
  background-color: rgba(0, 0, 0, .5);

  > div:nth-child(1) {
    font-size: 20px;
    color: white;
    margin-bottom: 5px;
  }
}

::v-deep .flip-card {
  font-size: 24px;
}

::v-deep .inline-countdown {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px; /* 调整数字和单位之间的间距 */
}

::v-deep .flip-clock {
  display: flex;
  align-items: center;
}

::v-deep .flip-clock__piece {
  display: flex;
  align-items: center;
  margin: 0;
}

::v-deep .flip-clock__slot {
  margin-left: 5px; /* 调整单位（天/小时等）的位置 */
  font-size: 16px; /* 可选：调整单位文字大小 */
  color: white;
  font-weight: bolder;
}

::v-deep .flip-card__top {
  color: white;
}

::v-deep .flip-card__bottom {
  color: white;
}

::v-deep .flip-card__back::before {
  color: white;
}

::v-deep .flip-card__back-bottom {
  color: white;
}

.tip {
  color: #999;
  margin-top: 4px;
  font-size: 10px;
}

.live-bars {
  display: flex;
  align-items: flex-end; /* 让竖线底部对齐 */
  gap: 4px; /* 竖线之间的间距 */
  height: 25px; /* 容器高度 */
  margin-right: 5px;
}

.bar {
  width: 4px; /* 竖线宽度 */
  background-color: #1890ff; /* 蓝色（类似直播状态色） */
  border-radius: 2px; /* 圆角 */
  animation: bounce 0.6s infinite ease-in-out alternate; /* 上下弹跳动画 */
}

/* 每根竖线设置不同的动画延迟，形成错落效果 */
.bar:nth-child(1) {
  height: 15px; /* 第一根高度 */
  animation-delay: -0.2s; /* 提前开始动画 */
}

.bar:nth-child(2) {
  height: 25px; /* 第二根高度（最高） */
  animation-delay: 0s; /* 正常开始 */
}

.bar:nth-child(3) {
  height: 20px; /* 第三根高度 */
  animation-delay: 0.2s; /* 延迟开始 */
}

/* 弹跳动画：上下移动并改变高度（模拟升降） */
@keyframes bounce {
  0% {
    transform: scaleY(0.5); /* 压缩高度 */
    opacity: 0.6; /* 半透明 */
  }
  100% {
    transform: scaleY(1.2); /* 拉伸高度 */
    opacity: 1; /* 不透明 */
  }
}

.outBox {
  width: 1200px;
  margin: auto;
  background: #ededed;
  padding: 10px 0;
  overflow: hidden;

  .topBox {
    width: 1200px;
    background: white;
    margin: auto;
    padding: 10px 0;
    border-radius: 5px;

    .headerBox {
      display: flex;
      align-content: center;
      flex-wrap: wrap;
      justify-content: center;

      .left-box {
        width: 514px;
        height: 265px;
        position: relative;

        .liveTime {
          position: absolute;
        }

        img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
      }

      .right-box {
        width: 600px;
        margin-left: 25px;
        display: flex;
        flex-direction: column;

        .right-box-title {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .right-box-share {
          font-size: 14px;
          color: #666;
          margin: 10px 0 15px 0;
        }

        .right-box-time {
          font-size: 16px;
          color: #999;
          margin-bottom: 10px;

          .right-box-free {
            width: 100%;
            font-size: 28px;
            color: #5fb41b;
            background-color: #f8f9fa;
            padding: 10px;
            border-radius: 5px;
          }
        }

        .right-box-look {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 110px;
          margin-top: auto; /* 关键：让按钮自动占据剩余空间，推到最下方 */
          font-size: 20px;
          border-radius: 8px;
          border: 1px solid #2a84e9;
          padding: 5px 10px;
          background-color: #edf4fe !important;
          color: #2a84e9;
          cursor: pointer;
        }

        .noOk {
          background-color: #ff7800 !important;
          color: #fff;
          cursor: not-allowed;
          border: 1px solid #ff7800;
        }

        .outOk {
          background-color: #ededed !important;
          color: #726f6f;
          cursor: not-allowed;
          border: 1px solid #ededed;
        }
      }
    }
  }
}

.bottomBox {
  width: 1200px;
  margin: 15px auto auto;

  .bottomBox-flex {
    display: flex;
    align-items: stretch;
    justify-content: center;
    margin: auto;

    .left-box {
      background: white;
      width: 850px;
      border-radius: 3px;

      > div:nth-child(1) {
        font-size: 18px;
        padding: 10px;
        border-bottom: 1px solid #ededed;
      }

      > div:nth-child(2) {
        padding: 10px;

        //> div:nth-child(1) {
        //  font-size: 16px;
        //  font-weight: bold;
        //  margin-bottom: 10px;
        //}
      }
    }

    .right-box {
      width: 346px;
      margin-left: 15px;

      .right-box-teacher {
        display: flex;
        background: white;
        padding: 15px;
        border-radius: 3px;

        > div:nth-child(1) {
          > img {
            width: 65px;
            height: 65px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        > div:nth-child(2) {
          > div:nth-child(1) {
            margin-bottom: 5px;
            font-size: 16px;
            font-weight: bold;
          }

          > div:nth-child(2) {
            display: block;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.5em;
            max-height: 4.5em; /* 1.5em × 3行 */
          }
        }
      }

      .right-box-recomme {
        margin-top: 10px;
        background: white;
        border-radius: 4px;

        > div {
          padding: 15px;
        }

        .right-box-recomme-list {
          margin-top: 10px;

          > div {
            display: flex;
            align-items: flex-start;
            justify-content: left;
            margin-bottom: 10px;
            cursor: pointer;

            > div:nth-child(1) {
              margin-right: 5px;

              > img {
                width: 80px;
                height: 47px;
                border-radius: 5px;
              }
            }

            > div:nth-child(2) {
              flex: 1;
              min-width: 0; /* 关键修复 */

              > div:nth-child(1) {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-bottom: 5px;
                font-weight: 550;
              }

              > div:nth-child(2) {
                font-size: 12px;
                color: #999;
              }
            }
          }

          > div:hover {
            > div:nth-child(1) {
              margin-right: 5px;

              > img {
                transform: scale(1.1); /* 放大1.1倍 */
                transition: transform 0.3s ease; /* 添加平滑过渡效果 */
              }
            }

            > div:nth-child(2) {
              > div:nth-child(1) {
                color: #ff7800;
              }
            }
          }
        }
      }
    }

  }
}
</style>

<script>
import FlipCountdown from "vue2-flip-countdown"
import {getLiveStreamById, getTeacherByUserId, getListLivestream, joinChannel} from "@/api/live";


export default {
  components: {FlipCountdown},
  data() {
    return {
      broadcastChannel: null, // 保存 BroadcastChannel 实例
      liveTime: "",
      star: 5,
      nowData: "",
      liveData: {},
      teacherData: {},
      recommendList: [],
      liveState: null, //0未开始 1直播中 2已结束
      recorder: null,
      videoData: [],
      errorMessage: null,
      fileName: null,
      events: [],
      playbackDataFalg: false,
      useInfo: {}
    }
  },
  computed: {
    formattedLiveTime() {
      if (!this.liveData.livesteramTime || !this.liveData.livesteramEndTime) return '';
      const start = new Date(this.liveData.livesteramTime);
      const end = new Date(this.liveData.livesteramEndTime);

      // 判断是否同年同月同日
      const isSameDay = start.getFullYear() === end.getFullYear() &&
          start.getMonth() === end.getMonth() &&
          start.getDate() === end.getDate();

      // 格式化日期时间（补零）
      const formatDateTime = (date, showFullDate) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        // const seconds = String(date.getSeconds()).padStart(2, '0');

        if (showFullDate) {
          return `${year}-${month}-${day} ${hours}:${minutes}`;//:${seconds}
        } else {
          return `${hours}:${minutes}`;
        }
      };

      // 如果同年同月同日，结束时间省略年月日；否则显示完整格式
      return `${formatDateTime(start, true)} - ${formatDateTime(end, !isSameDay)}`;
    }
  },

  mounted() {
    let token = JSON.parse(localStorage.getItem("USER_AUTH_INFO"))
        ? JSON.parse(localStorage.getItem("USER_AUTH_INFO"))
        : "";
    if (token && token.nickName) {
      this.useInfo = JSON.parse(localStorage.getItem('USER_AUTH_INFO'));
    }

    const data = JSON.parse(sessionStorage.getItem('previousPageData'));
    if (data) {
      this.upPlayBack(data.data)
    }
    getLiveStreamById({roomId: this.$route.query.id}).then(res => {
      if (res.code === 200) {
        this.liveData = res.data;
        const date = new Date(this.liveData.livesteramTime)
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        this.liveTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

        const timestamp_ms = Date.now(); // 当前时间戳（毫秒级）
        console.log("timestamp_ms", timestamp_ms)
        const {livesteramEndTime, livesteramTime, liveStatus} = res.data;// 直播开始、结束时间、后端状态
        console.log("liveStatus", liveStatus)
        const TEN_MINUTES = 10 * 60 * 1000; // 10分钟的毫秒数
        const THIRTY_MINUTES = 20 * 60 * 1000; // 30分钟的毫秒数

        // 默认优先使用后端状态（liveStatus）
        let computedLiveState = liveStatus;

        // 如果后端状态是 "未开始"（0），则前端计算是否提前进入
        if (liveStatus === 0) {

          if (this.useInfo.identity === 2) {
            // 讲师：提前30分钟内可进入
            if (
                (timestamp_ms >= livesteramTime - THIRTY_MINUTES && timestamp_ms <= livesteramEndTime) ||
                (timestamp_ms >= livesteramTime - TEN_MINUTES && timestamp_ms < livesteramTime)
            ) {
              computedLiveState = 1; // 直播中
            } else if (timestamp_ms > livesteramEndTime) {

              computedLiveState = 2; // 已结束
            } else {
              computedLiveState = 0; // 未开始
            }
          } else {
            // 普通用户：提前10分钟内可进入
            if (timestamp_ms >= livesteramTime - TEN_MINUTES && timestamp_ms <= livesteramEndTime) {
              computedLiveState = 1; // 直播中
            } else if (timestamp_ms > livesteramEndTime) {
              computedLiveState = 2; // 已结束
            } else {
              computedLiveState = 0; // 未开始
            }
          }
        }
        console.log("computedLiveState", computedLiveState)

        this.liveState = computedLiveState; // 最终状态

        // 获取讲师信息
        getTeacherByUserId({userUuid: res.data.userUuid}).then(teaRes => {
          if (teaRes.code === 200) {
            this.teacherData = teaRes.data;
          }
        });
      }
    });
  },
  created() {
    getListLivestream({current: 1, size: 8}).then(res => {
      if (res.code === 200) {
        this.recommendList = res.data.records
      }
    })
  },
  methods: {
    upPlayBack(message) {
      // 将消息按逗号分割成数组，然后用换行符连接
      const formattedMessage = message.split(',').join('\n');
      this.$alert(`${formattedMessage}`, '直播数据', {
        confirmButtonText: '确定',
        callback: action => {
          sessionStorage.removeItem('previousPageData'); // 立即清除
          getLiveStreamById({roomId: this.$route.query.id}).then(res => {
            if (res.code === 200) {
              this.liveData = res.data;
              const date = new Date(this.liveData.livesteramTime)
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              const hours = String(date.getHours()).padStart(2, '0');
              const minutes = String(date.getMinutes()).padStart(2, '0');
              const seconds = String(date.getSeconds()).padStart(2, '0');
              this.liveTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
              console.log(this.liveTime)

              const timestamp_ms = Date.now(); // 当前时间戳（毫秒级）
              const {livesteramEndTime, livesteramTime, liveStatus} = res.data; // 直播开始、结束时间、后端状态

              const TEN_MINUTES = 10 * 60 * 1000; // 10分钟的毫秒数
              const THIRTY_MINUTES = 30 * 60 * 1000; // 30分钟的毫秒数

              // 默认优先使用后端状态（liveStatus）
              let computedLiveState = liveStatus;

              // 如果后端状态是 "未开始"（0），则前端计算是否提前进入
              if (liveStatus === 0) {

                if (this.useInfo.identity === 2) {
                  // 讲师：提前30分钟内可进入
                  if (
                      (timestamp_ms >= livesteramTime - THIRTY_MINUTES && timestamp_ms <= livesteramEndTime) ||
                      (timestamp_ms >= livesteramTime - TEN_MINUTES && timestamp_ms < livesteramTime)
                  ) {
                    computedLiveState = 1; // 直播中
                  } else if (timestamp_ms > livesteramEndTime) {
                    computedLiveState = 2; // 已结束
                  } else {
                    computedLiveState = 0; // 未开始
                  }
                } else {
                  // 普通用户：提前10分钟内可进入
                  if (timestamp_ms >= livesteramTime - TEN_MINUTES && timestamp_ms <= livesteramEndTime) {
                    computedLiveState = 1; // 直播中
                  } else if (timestamp_ms > livesteramEndTime) {
                    computedLiveState = 2; // 已结束
                  } else {
                    computedLiveState = 0; // 未开始
                  }
                }
              }

              this.liveState = computedLiveState; // 最终状态

              // 获取讲师信息
              getTeacherByUserId({userUuid: res.data.userUuid}).then(teaRes => {
                if (teaRes.code === 200) {
                  this.teacherData = teaRes.data;
                }
              });
            }
          });
        }
      });
    },
    // 跳转
    goCourseDetails(id) {
      this.$router.push("/liveIndex?id=" + id);
    },
    timestampToTime(timestamp) {
      // 判断是10位还是13位时间戳（10位需要乘以1000）
      const date = new Date(
          timestamp.toString().length === 10
              ? timestamp * 1000
              : timestamp
      );
      const y = date.getFullYear();
      const MM = date.getMonth() + 1;
      const d = date.getDate();
      const h = date.getHours();
      const m = date.getMinutes();
      const s = date.getSeconds();
      // 补零操作
      const padZero = (num) => (num < 10 ? `0${num}` : num);
      return `${y}-${padZero(MM)}-${padZero(d)} ${padZero(h)}:${padZero(m)}:${padZero(s)}`;
    },
    joinLive() {
      let token = JSON.parse(localStorage.getItem("USER_AUTH_INFO"))
          ? JSON.parse(localStorage.getItem("USER_AUTH_INFO"))
          : "";
      if (token && token.nickName) {
        const useInfo = JSON.parse(localStorage.getItem('USER_AUTH_INFO'));
        joinChannel({
          roomUuid: this.liveData.roomUuid,
          userUuid: useInfo.id
        }).then(res => {
          if (res.code === 200) {
            const formData = {
              roomName: this.liveData.roomName,
              role: res.data.role,
              roomType: this.liveData.roomType,
              userUuid: String(useInfo.id),
              userName: useInfo.nickName,
              roomToken: res.data.roomToken,  //有效期是七天
              userToken: res.data.userToken, //有效期是七天
              roomUuid: res.data.roomUuid,
              timeInterval: (this.liveData.livesteramEndTime - this.liveData.livesteramTime) / 1000,
              startTime: this.liveData.livesteramTime
            };
            // 将数据保存到 localStorage（或者 sessionStorage）
            localStorage.setItem('liveBroadcastData', JSON.stringify(formData));
            window.location.href = '/liveBroadcast.html';
            /*if (res.data.role === 1) {
              this.startScreenRecording()
            } else {
              // this.$router.push('/liveLook');
              window.location.href = '/liveBroadcast.html';
            }*/
            // window.location.href = '/liveBroadcast.html';
          }
        })
      } else {
        const that = this
        this.$message.error({
          title: "错误",
          message: "请先登录再尝试观看！",
          duration: 1000,
          onClose() {
            that.$router.push('/personallogin')
          }
        });
      }

    }
  },
  beforeDestroy() {
    // 组件销毁时移除监听，避免内存泄漏
    if (this.broadcastChannel) {
      this.broadcastChannel.removeEventListener('message', this.handleApiEvent);
      this.broadcastChannel.close(); // 关闭频道
    }
  },
}

</script>
